module.exports = __webpack_public_path__ + "static/media/Kafka-logo.51993c21.png";